import { useState, useEffect } from "react";
import PlanCard from "./planCard";
import ContractModal from "./contractModal";
import { fetchPlans } from "../../../apis/plansApi";
import { fetchBranches } from "../../../apis/branchApi";
import { loadWompiScript, showPayModal } from "../../../components/paymentIntegrations/Wompi";
import { useLoading } from "../../../components/LoadingContext";
import SelectBranch from "../../../components/selectBranch";

const Plans = () => {
    const [plans, setPlans] = useState([]);
    const [branches, setBranches] = useState([]); // State for branches
    
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const { setLoading } = useLoading();


    const loadBranches = async () => {
        const branches = await fetchBranches();
        if(branches.length === 1) {
            loadPlans(branches[0].id);
            return;
        }
        setBranches(branches);
    };

    const loadPlans = async (branchId) => {
        const plans = await fetchPlans(branchId);
        setPlans(plans);
    };

    useEffect(() => {
        (async () => {
            await loadWompiScript();
            await loadBranches();
        })();
    }, []);


    const handleViewContract = (plan, contractType) => {
        setSelectedPlan({
            ...plan,
            contract: contractType === "automatic" ? plan.contract_automatic : plan.contract_unique,
        });
        setModalVisible(true);
    };

    const handlePlanSelection = async (plan, paymentOption) => {
        await showPayModal({
            plan: plan, 
            paymentOption: paymentOption,
            setLoading: setLoading
        });
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setSelectedPlan(null);
    };

    return (
        <div className="container-fluid p-5" style={{minHeight:"80vh"}}>
            {branches.length > 1 && (
                <SelectBranch 
                    onChange={(branchId) => {
                        setSelectedPlan(null);
                        loadPlans(branchId);
                    }}
                    branches={branches}
                />
            )}

            {/* Plans */}
            <div className="d-md-flex justify-content-between justify-content-md-around m-auto flex-wrap">
                {plans.map((plan) =>
                    plan.available_plans === null || plan.available_plans > 0 ? (
                        <PlanCard
                            key={plan.plan_id}
                            plan={plan}
                            onViewContract={handleViewContract}
                            onSubmit={handlePlanSelection}
                        />
                    ) : null
                )}
                {modalVisible && (
                    <ContractModal
                        contract={selectedPlan?.contract}
                        onClose={handleCloseModal}
                    />
                )}
            </div>
        </div>
    );
};

export default Plans;
